import React from 'react';
import { Box } from "@mui/system";
import { Button } from '@mui/material';
import { LAYOUT_STYLES } from './styles';
import { ActionButtonsProps, ButtonConfig } from './types';

export const ActionButtons: React.FC<ActionButtonsProps> = ({
    isLastStep,
    isSaving,
    isFormValid,
    onBack,
    onCancel,
    onNext,
    onSave
}) => {
    const buttonConfigs: ButtonConfig[] = [
        {
            key: 'secondary',
            variant: 'outlined',
            onClick: isLastStep ? onBack : onCancel,
            disabled: isSaving,
            text: isLastStep ? 'Back' : 'Cancel'
        },
        {
            key: 'primary',
            variant: 'contained',
            color: 'primary',
            onClick: isLastStep ? onSave : onNext,
            disabled: isSaving || isFormValid,
            text: isLastStep ? 'Save' : 'Next'
        }
    ];

    return (
        <Box sx={LAYOUT_STYLES.buttonContainer}>
            {buttonConfigs.map(({ key, variant, color, onClick, disabled, text }) => (
                <Button
                    key={key}
                    variant={variant}
                    color={color}
                    onClick={onClick}
                    disabled={disabled}
                >
                    {text}
                </Button>
            ))}
        </Box>
    );
};
